import { ProcessData } from "@/pages/caster/models/ProcessData";
import { CircularProgress, IconButton } from "@material-ui/core";
import { Link, LinkOff } from "@material-ui/icons";

interface LinkUnlinkButtonProps {
	process: ProcessData;
	onButtonClick: () => void;
	loading: boolean;
}

export const LinkUnlinkButton = ({
	process,
	onButtonClick,
	loading,
}: LinkUnlinkButtonProps) => {
	return (
		<>
			<IconButton
				size={"small"}
				title={process.HeatId ? "Unlink" : "Link"}
				onClick={onButtonClick}
				style={{
					color: process.HeatId ? "red" : "#3f51b5",
				}}
			>
				{loading ? (
					<CircularProgress size="1.5rem" />
				) : process?.HeatId === null ? (
					<Link style={{ cursor: "pointer" }} />
				) : (
					<LinkOff style={{ cursor: "pointer" }} />
				)}
			</IconButton>
		</>
	);
};
